// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"excited"},"children":[{"tag":"path","attrs":{"id":"fill1","fill":"props.fillColor1","d":"M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z"}},{"tag":"path","attrs":{"id":"fill2","fill":"props.fillColor2","d":"M12.001 13.5C11.501 14.5 10.751 15 10.001 15.0625C10.3343 16.0417 11.201 18 12.001 18C12.801 18 13.6676 16.0417 14.001 15.0625C13.251 15 12.501 14.5 12.001 13.5Z"}},{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}},{"tag":"path","attrs":{"id":"stroke2","stroke":"props.strokeColor2","d":"M16 8.5L14 9.62501L14 10L16 11.5M8 8.5L10 9.62501L10 10L8.00001 11.5M15.3143 14.7043C14.2568 15.4235 12.8053 15.1088 12.0009 13.5C11.1965 15.1088 9.74503 15.4235 8.6875 14.7043M13.9164 15.3C13.537 16.3265 12.7404 18 12.0009 18C11.2614 18 10.4648 16.3265 10.0853 15.3","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const ExcitedIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'excited',
    ref,
    icon: element,
  },
));

ExcitedIcon.displayName = 'ExcitedIcon';

export default ExcitedIcon;
